/* English dictionary: settings namespace. See src/i18n/README.md. */

import type { TextSpec } from '../text';

const settings = {
  'settings.section.language': [ 'Language' ],
  'settings.languageNote': [ 'Applies immediately. Defaults to your browser language on first run.' ],
  'settings.section.gamepad': [ 'Gamepad' ],
  'settings.gamepadNintendo': [ 'Nintendo layout' ],
  'settings.gamepadXbox': [ 'Xbox layout' ],
  'settings.gamepadNote': [ 'Swaps the physical A/B and X/Y positions (actions stay bound to the letters). Nintendo is the default: A on the right, B on the bottom.' ],
  'settings.section.audio': [ 'Audio' ],
  'settings.bgmVolume': [ 'BGM volume' ],
  'settings.sfxVolume': [ 'SFX volume' ],
  'settings.section.interface': [ 'Interface' ],
  'settings.uiScale': [ 'UI scale' ],
  'settings.uiScaleNote': [ 'UI scaling is not implemented yet.' ],
  'settings.section.lore': [ 'Card text' ],
  'settings.loreNote': [ 'Choose which sections appear when hovering a card. Combo entries on powerless cards (such as "Effect: Pair") follow the "Effect" toggle.' ],
  'settings.section.save': [ 'Save' ],
  'settings.export': [ 'Export settings' ],
  'settings.exported': [ 'Settings exported' ],
  'settings.exportFailed': [ 'Export failed: ', { type: 'param', name: 'reason' } ],
  'settings.resetDone': [ 'Defaults restored' ],
} as const;

// 静态检查（写在对象字面量之外，避免 TextKey 循环推断）
settings satisfies Record<string, TextSpec>;
export default settings;
